import React, { ReactChild, ReactChildren } from 'react'
import BootstrapNav from 'react-bootstrap/Nav'
import { Link } from 'react-router-dom'
import { itemStyle, navLinkStyle } from './styles'
import Icon from './NavIcon'
import { IconOption } from '../Icon/icons'
import { isIconOption } from '../Icon'

interface NavLinkProps {
    text: string
    path: string
    children?: ReactChildren | ReactChild | ReactChild[]
    icon?: IconOption | string
    style?: React.CSSProperties
    iconSize?: number
}

const NavLink = ({
    text, path, children, icon, style, iconSize
}: NavLinkProps) => (
    <BootstrapNav.Item style={{ ...itemStyle, ...style }}>
        <BootstrapNav.Link
            as={Link}
            to={path}
            style={navLinkStyle}
        >
            {
                icon && isIconOption(icon)
                    ? <Icon icon={icon} size={iconSize} />
                    : <span style={{ marginRight: 5 }} />
            }
            {
                children || <span>{ text }</span>
            }
        </BootstrapNav.Link>
    </BootstrapNav.Item>
)

export default NavLink
